export default "__VITE_ASSET__JzLLzN6E__"